// extracted by mini-css-extract-plugin
export default {"CheckBox":"MappingList_CheckBox__DdquK"};